import {UI_COLORS} from '@/utils/ui-colors';

const DEFAULT_DIALOG_BACKDROP_SETTINGS = {
    dialog_backdrop_color: UI_COLORS.text.muted,
    dialog_backdrop_alpha: 0.75,
    dialog_backdrop_blur: 0,
};

const clamp = function (value, min, max) {
    return Math.min(Math.max(value, min), max);
};

const normalizeColor = function (value) {
    const normalized = String(value || '').trim();
    if (/^#(?:[0-9a-fA-F]{3}){1,2}$/.test(normalized)) {
        return normalized.toLowerCase();
    }

    return DEFAULT_DIALOG_BACKDROP_SETTINGS.dialog_backdrop_color;
};

const normalizeAlpha = function (value) {
    const normalized = Number.parseFloat(value);
    if (!Number.isFinite(normalized)) {
        return DEFAULT_DIALOG_BACKDROP_SETTINGS.dialog_backdrop_alpha;
    }

    return Number(clamp(normalized, 0, 1).toFixed(2));
};

const normalizeBlur = function (value) {
    const normalized = Number.parseInt(value, 10);
    if (!Number.isFinite(normalized)) {
        return DEFAULT_DIALOG_BACKDROP_SETTINGS.dialog_backdrop_blur;
    }

    return clamp(normalized, 0, 40);
};

const colorToRgb = function (value) {
    const color = normalizeColor(value).replace('#', '');
    const normalized = color.length === 3
        ? color.split('').map((part) => part + part).join('')
        : color;

    return {
        r: Number.parseInt(normalized.slice(0, 2), 16),
        g: Number.parseInt(normalized.slice(2, 4), 16),
        b: Number.parseInt(normalized.slice(4, 6), 16),
    };
};

export const normalizeDialogBackdropSettings = function (source = {}) {
    return {
        dialog_backdrop_color: normalizeColor(source.dialog_backdrop_color),
        dialog_backdrop_alpha: normalizeAlpha(source.dialog_backdrop_alpha),
        dialog_backdrop_blur: normalizeBlur(source.dialog_backdrop_blur),
    };
};

export const buildDialogBackdropBackground = function (source = {}) {
    const settings = normalizeDialogBackdropSettings(source);
    const rgb = colorToRgb(settings.dialog_backdrop_color);

    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${settings.dialog_backdrop_alpha})`;
};

export const applyDialogBackdropSettings = function (source = {}) {
    const settings = normalizeDialogBackdropSettings(source);
    const root = typeof document !== 'undefined' ? document.documentElement : null;

    if (root && root.style) {
        root.style.setProperty('--dialog-backdrop-color', settings.dialog_backdrop_color);
        root.style.setProperty('--dialog-backdrop-alpha', String(settings.dialog_backdrop_alpha));
        root.style.setProperty('--dialog-backdrop-blur', `${settings.dialog_backdrop_blur}px`);
        root.style.setProperty('--dialog-backdrop-rgba', buildDialogBackdropBackground(settings));
    }

    return settings;
};
